import { render, staticRenderFns } from "./GroupSubgroups.vue?vue&type=template&id=5bf88a8b"
import script from "./GroupSubgroups.vue?vue&type=script&lang=js"
export * from "./GroupSubgroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports